<div class="d-flex align-items-center justify-content-center vh-100 overflow-auto flex-wrap">

    <!-- Page Wrapper -->
    <div class="content">
        <div class="container">
            <div class="main-logo text-center">
                <img src="assets/img/logo-dark.svg" alt="Img">
            </div>
            <div class="maintenance-img text-center">
                <img src="assets/img/under-maintenance.svg" alt="Img">
            </div>
            <div class="maintenance-update">
                <div class="text-center">
                    <div class="row justify-content-center mb-3">
                        <div class="col-md-7">
                            <p class="text-gray-6 text-center">Please check back later, We are working hard to get everything just right.</p>
                        </div>
                    </div>
                    <h6 class="fs-14 mb-3">Subscribe to get notified</h6>
                </div>
                <div class="input-group justify-content-center mx-auto mb-3">
                    <input type="email" class="form-control" placeholder="Enter your Email">
                    <button type="submit" class="btn btn-primary rounded-pill">Subscribe</button>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                    <ul class="d-flex justify-content-center align-items-center">
                        <li>
                            <a href="javascript:void(0);" class="bg-primary avatar avatar-md rounded-circle text-white me-2"><i class="fa-brands fa-facebook fs-16"></i></a>
                        </li>
                        <li>
                            <a href="javascript:void(0);" class="bg-primary avatar avatar-md rounded-circle text-white me-2"><i class="fa-brands fa-x-twitter fs-16"></i></a>
                        </li>
                        <li>
                            <a href="javascript:void(0);" class="bg-primary avatar avatar-md rounded-circle text-white me-2"><i class="fa-brands fa-instagram fs-16"></i></a>
                        </li>
                        <li>
                            <a href="javascript:void(0);" class="bg-primary avatar avatar-md rounded-circle text-white me-2"><i class="fa-brands fa-linkedin fs-16"></i></a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- Page Wrapper -->
</div>